export type LatestMessageActor = "participant" | "agent" | "workspace_member"

export interface FormatLatestActorNameOptions {
  actor?: LatestMessageActor
  actorName?: string | null
  participantName?: string | null
  agentName?: string | null
  getFallbackName: (actor: LatestMessageActor) => string
}

export const formatLatestActorName = ({
  actor = "agent",
  actorName,
  participantName,
  agentName,
  getFallbackName,
}: FormatLatestActorNameOptions) => {
  const resolvedActorName = actorName?.trim()
  const resolvedAgentName = agentName?.trim()

  if (actor === "workspace_member") {
    const visibleAgentName = resolvedAgentName || getFallbackName("agent")
    const workspaceMemberName =
      resolvedActorName || getFallbackName("workspace_member")
    return `${visibleAgentName} (${workspaceMemberName})`
  }

  return (
    resolvedActorName ||
    (actor === "participant" ? participantName?.trim() : "") ||
    (actor === "agent" ? resolvedAgentName : "") ||
    getFallbackName(actor)
  )
}
